import { render, staticRenderFns } from "./about-certificate.vue?vue&type=template&id=2deb3e0c"
import script from "./about-certificate.vue?vue&type=script&lang=js"
export * from "./about-certificate.vue?vue&type=script&lang=js"
import style0 from "./about-certificate.vue?vue&type=style&index=0&id=2deb3e0c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports